export const TOURNAMENT_ROLES = {
  HOLDER: 'holder',
  MAINTAINER: 'maintainer',
  PARTICIPANT: 'participant',
} as const;

export type TournamentRole = typeof TOURNAMENT_ROLES[keyof typeof TOURNAMENT_ROLES];

export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  GUEST: 'guest',
  END_USER: 'end_user',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];
